import { render, staticRenderFns } from "./MaterialCreateModal.vue?vue&type=template&id=acdb372c&scoped=true"
import script from "./MaterialCreateModal.vue?vue&type=script&lang=js"
export * from "./MaterialCreateModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialCreateModal.vue?vue&type=style&index=0&id=acdb372c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdb372c",
  null
  
)

export default component.exports